export const POIToAcceptMock = 
[
  
    {
      "id": 50,
      "author": "Nguyen",
      "category": "exercitation",
      "isGlobaL": true,
      "name": "Lorem",
      "description": "Velit amet tempor commodo reprehenderit sunt ipsum mollit veniam amet.",
      "x": 52.223754826,
      "y": 21.152232057
    },
    {
      "id": 51,
      "author": "Rosanna",
      "category": "ut",
      "isGlobaL": true,
      "name": "consectetur",
      "description": "Commodo velit dolore minim pariatur reprehenderit esse cupidatat proident labore aute cupidatat et magna eu.",
      "x": 52.296015938,
      "y": 20.983102807
    },
    {
      "id": 52,
      "author": "Hannah",
      "category": "duis",
      "isGlobaL": true,
      "name": "tempor",
      "description": "Elit qui non cillum aute eiusmod amet esse est labore Lorem exercitation ea.",
      "x": 52.192725059,
      "y": 20.952040907
    },
    {
      "id": 53,
      "author": "Mendez",
      "category": "laborum",
      "isGlobaL": true,
      "name": "excepteur",
      "description": "Eu aliquip sit exercitation sit occaecat dolor consequat.",
      "x": 52.239075749,
      "y": 21.030982096
    },
    {
      "id": 54,
      "author": "Hays",
      "category": "amet",
      "isGlobaL": true,
      "name": "Lorem",
      "description": "Cillum excepteur est eu sunt esse duis non quis qui veniam.",
      "x": 52.235052776,
      "y": 20.996663423
    },
    {
      "id": 55,
      "author": "Cannon",
      "category": "proident",
      "isGlobaL": true,
      "name": "quis",
      "description": "Nostrud elit occaecat incididunt exercitation nulla duis laborum sit.",
      "x": 52.251598808,
      "y": 21.128810088
    },
    {
      "id": 56,
      "author": "Miriam",
      "category": "amet",
      "isGlobaL": true,
      "name": "laborum",
      "description": "Nisi quis id non eu tempor non velit esse deserunt sint est duis enim.",
      "x": 52.296983626,
      "y": 21.108156523
    },
    {
      "id": 57,
      "author": "Ella",
      "category": "officia",
      "isGlobaL": true,
      "name": "exercitation",
      "description": "Cupidatat dolore irure nisi ea.",
      "x": 52.248187755,
      "y": 21.163711975
    },
    {
      "id": 58,
      "author": "Castaneda",
      "category": "non",
      "isGlobaL": true,
      "name": "reprehenderit",
      "description": "Est culpa cupidatat Lorem veniam aliqua eu sint dolor.",
      "x": 52.259780739,
      "y": 20.999561383
    },
    {
      "id": 59,
      "author": "Gregory",
      "category": "consequat",
      "isGlobaL": true,
      "name": "velit",
      "description": "Aliquip anim anim adipisicing et anim qui sunt reprehenderit et amet cillum.",
      "x": 52.169040383,
      "y": 20.922566319
    },
    {
      "id": 60,
      "author": "Barlow",
      "category": "duis",
      "isGlobaL": true,
      "name": "occaecat",
      "description": "Nisi veniam proident magna elit excepteur anim.",
      "x": 52.290420995,
      "y": 21.166484811
    },
    {
      "id": 61,
      "author": "Byrd",
      "category": "laborum",
      "isGlobaL": true,
      "name": "tempor",
      "description": "Duis excepteur ea do aliqua non pariatur dolor ullamco do ut minim.",
      "x": 52.340828805,
      "y": 20.909392926
    },
    {
      "id": 62,
      "author": "Nichole",
      "category": "sunt",
      "isGlobaL": true,
      "name": "exercitation",
      "description": "Ad in laborum adipisicing velit qui minim sunt ad qui incididunt mollit dolore.",
      "x": 52.229345973,
      "y": 21.077828549
    },
    {
      "id": 63,
      "author": "Alvarado",
      "category": "sit",
      "isGlobaL": true,
      "name": "non",
      "description": "Ut laboris excepteur excepteur proident nulla irure ad consectetur adipisicing esse consequat duis.",
      "x": 52.216446264,
      "y": 20.995704496
    },
    {
      "id": 64,
      "author": "Mercedes",
      "category": "qui",
      "isGlobaL": true,
      "name": "duis",
      "description": "Dolor commodo eiusmod nisi cillum cupidatat culpa eu voluptate.",
      "x": 52.268732481,
      "y": 21.084887003
    },
    {
      "id": 65,
      "author": "Leanne",
      "category": "minim",
      "isGlobaL": true,
      "name": "et",
      "description": "Nulla reprehenderit irure fugiat enim incididunt exercitation officia pariatur pariatur.",
      "x": 52.239086194,
      "y": 21.156317405
    },
    {
      "id": 66,
      "author": "Miranda",
      "category": "dolore",
      "isGlobaL": true,
      "name": "aliqua",
      "description": "Occaecat et exercitation exercitation nulla irure qui aliqua id sint do consequat duis incididunt.",
      "x": 52.292092826,
      "y": 21.010057432
    },
    {
      "id": 67,
      "author": "Shannon",
      "category": "ex",
      "isGlobaL": true,
      "name": "excepteur",
      "description": "Excepteur laboris exercitation qui occaecat laboris voluptate in cillum.",
      "x": 52.286380111,
      "y": 20.901301906
    },
    {
      "id": 68,
      "author": "Rene",
      "category": "eiusmod",
      "isGlobaL": true,
      "name": "labore",
      "description": "Voluptate commodo et occaecat exercitation elit excepteur non aute dolore Lorem in veniam labore reprehenderit.",
      "x": 52.342188564,
      "y": 20.951728408
    },
    {
      "id": 69,
      "author": "Torres",
      "category": "deserunt",
      "isGlobaL": true,
      "name": "duis",
      "description": "Cillum deserunt anim et eu eiusmod non excepteur commodo sit fugiat consequat mollit eiusmod nulla.",
      "x": 52.264239845,
      "y": 20.940645803
    }
  
]